import CustomNavbar from "../../components/common/CustomNavbar";
import PageLayout from "../../components/layouts/PageLayout";
import { whtsappIcon, bulkUser, singleUser } from "../../asset";
import { useNavigate, useParams } from "react-router-dom";
import SendMsgComponentVariables from "./SendMsgComponentVariables";

type MessageMode = "single" | "bulk" | "broadcast";

const MODES: { mode: MessageMode; label: string; title: string; icon: string }[] = [
  { mode: "bulk", label: "Bulk Message", title: "BULK", icon: bulkUser },
  { mode: "broadcast", label: "Broadcast Message", title: "BROADCAST", icon: bulkUser },
  { mode: "single", label: "Single Message", title: "SINGLE", icon: singleUser },
];

export default function SendMessageVariables() {
  const navigate = useNavigate();
  const { mode } = useParams<{ mode: MessageMode }>();

  // Unknown / missing mode → bulk (same default as before)
  const currentMode: MessageMode =
    mode === "single" || mode === "broadcast" || mode === "bulk"
      ? mode : "bulk";

  const current = MODES.find((m) => m.mode === currentMode)!;

  return (
    <PageLayout
      customNavbar={
        <CustomNavbar>
          <div className="flex gap-3 items-center w-max">
            <img src={whtsappIcon} className="w-10 h-10" />
            <span className="font-bold text-lg uppercase">
              SEND {current.title} WHATSAPP MESSAGE
            </span>
          </div>
        </CustomNavbar>
      }
    >
      {/* Top action bar */}
      <div className="rounded-4xl w-full p-4 flex items-center justify-end">
        <div className="flex flex-wrap gap-3">
          {MODES.map((m) => (
            <button
              key={m.mode}
              onClick={() => navigate(`/admin/variables-send-message/${m.mode}`)}
              className={`flex items-center text-sm gap-2 px-4 py-2 rounded-full border font-semibold transition
                ${currentMode === m.mode
                  ? "bg-brand-blue-gradient text-white border-transparent"
                  : "border-gray-300 hover:bg-brand-blue-gradient hover:text-white"
                }`}
            >
              <img src={m.icon} className="w-4 h-4" />
              {m.label}
            </button>
          ))}
        </div>
      </div>

      {/* Render form inline — pass mode as prop */}
      <SendMsgComponentVariables mode={currentMode} />
    </PageLayout>
  );
}
